// eslint-disable-next-line @typescript-eslint/no-unused-vars

/**
 * Drive 在线列表项
 */

/**
 * Drive 本地文件列表项
 */

/**
 * @deprecated 请使用 @tencent/docs-mime-types 导出的DocType
 * 文档类型. */
export var DocType = /*#__PURE__*/function (DocType) {
  DocType[DocType["All"] = -1] = "All";
  DocType[DocType["Doc"] = 0] = "Doc";
  DocType[DocType["Sheet"] = 1] = "Sheet";
  DocType[DocType["Form"] = 2] = "Form";
  DocType[DocType["Folder"] = 3] = "Folder";
  DocType[DocType["Slide"] = 4] = "Slide";
  DocType[DocType["Note"] = 5] = "Note";
  DocType[DocType["PDF"] = 6] = "PDF";
  DocType[DocType["MiniProgram"] = 7] = "MiniProgram";
  DocType[DocType["SmartCanvas"] = 8] = "SmartCanvas";
  DocType[DocType["Unknown"] = 10] = "Unknown";
  DocType[DocType["RelationGraph"] = 89] = "RelationGraph";
  DocType[DocType["MindMap"] = 90] = "MindMap";
  DocType[DocType["FlowChart"] = 91] = "FlowChart";
  DocType[DocType["File"] = 100] = "File";
  DocType[DocType["CloudFile"] = 101] = "CloudFile";
  DocType[DocType["SogouSpeech"] = 102] = "SogouSpeech";
  DocType[DocType["Addon"] = 110] = "Addon";
  return DocType;
}({});

/** 腾讯文档品类的后缀 */
export var TencentDocExt = /*#__PURE__*/function (TencentDocExt) {
  TencentDocExt["TencentDoc"] = "tencentdoc";
  TencentDocExt["TencentSheet"] = "tencentsheet";
  TencentDocExt["TencentForm"] = "tencentform";
  TencentDocExt["TencentSlide"] = "tencentslide";
  TencentDocExt["SmartCanvas"] = "smartcanvas";
  TencentDocExt["ProcessOnMindMap"] = "mind";
  TencentDocExt["ProcessOnFlowChart"] = "flowchart";
  TencentDocExt["SogouSpeech"] = "sogspeech";
  TencentDocExt["PDF"] = "pdf";
  TencentDocExt["AIO"] = "aio";
  TencentDocExt["Addon"] = "addon";
  TencentDocExt["TencentExercises"] = "tencentexercises";
  TencentDocExt["TencentClock"] = "tencentclock";
  TencentDocExt["TencentSequence"] = "tencentsequence";
  TencentDocExt["SmartSheet"] = "smartsheet";
  TencentDocExt["Unknown"] = "";
  TencentDocExt["Board"] = "board";
  return TencentDocExt;
}({});

/* 腾讯文档不同品类的 mimeType */
export var TencentDocMimeType = /*#__PURE__*/function (TencentDocMimeType) {
  TencentDocMimeType["TencentCollaborationSpace"] = "application/vnd.tdocs-apps.collaboration-space";
  TencentDocMimeType["TencentCollaborationSpaceRoot"] = "application/vnd.tdocs-apps.collaboration-space-root";
  TencentDocMimeType["TecentFolder"] = "application/vnd.tdocs-apps.folder";
  TencentDocMimeType["TencentFolder"] = "application/vnd.tdocs-apps.folder";
  TencentDocMimeType["TencentDoc"] = "application/vnd.tdocs-apps.doc";
  TencentDocMimeType["TencentSheet"] = "application/vnd.tdocs-apps.sheet";
  TencentDocMimeType["TencentSlide"] = "application/vnd.tdocs-apps.slide";
  TencentDocMimeType["PDF"] = "application/pdf";
  TencentDocMimeType["TencentForm"] = "application/vnd.tdocs-apps.form";
  TencentDocMimeType["ProcessOnMindMap"] = "application/vnd.tdocs-apps.mind";
  TencentDocMimeType["ProcessOnFlowChart"] = "application/vnd.tdocs-apps.flowchart";
  TencentDocMimeType["SogouSpeech"] = "application/vnd.tdocs-apps.rec";
  TencentDocMimeType["SmartCanvas"] = "application/vnd.tdocs-apps.smartcanvas";
  TencentDocMimeType["SmartSheet"] = "application/vnd.tdocs-apps.smartsheet";
  TencentDocMimeType["Board"] = "application/vnd.tdocs-apps.board";
  return TencentDocMimeType;
}({});

/** 腾讯文档插件的 mimeType 前缀，和 clientId 拼接成完整的 mimeType */
export var TencentDocAddonMimeTypePrefix = /*#__PURE__*/function (TencentDocAddonMimeTypePrefix) {
  TencentDocAddonMimeTypePrefix["Image"] = "application/vnd.tdocs-addon-image.";
  TencentDocAddonMimeTypePrefix["Audio"] = "application/vnd.tdocs-addon-audio.";
  TencentDocAddonMimeTypePrefix["Video"] = "application/vnd.tdocs-addon-video.";
  TencentDocAddonMimeTypePrefix["Text"] = "application/vnd.tdocs-addon-text.";
  return TencentDocAddonMimeTypePrefix;
}({});
//# sourceMappingURL=file-node.js.map